import { defineFcm } from '../shared/factory';

export const FCM_STARTER_EXPERIENCE_AI_VANITY_URL_SUGGESTION = defineFcm('starter_experience_ai_vanity_url_suggestion')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-axolotl',
		scope: ['corgi-front-end', 'llm-service'],
		context: 'LLM Prompt Executor — petition vanity URL suggestion generation',
		description:
			'Gates whether the LLM Prompt Executor generates custom petition URL candidates on petition creation. Disabling it stops new generations but does not hide suggestions that were already stored.',
		import: false,
	});
